import React from 'react';
import {
  Radar,
  RadarChart as RechartsRadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer,
  Legend,
} from 'recharts';

interface RadarDataItem {
  dimensao: string;
  percentual: number;
  mediaEstadual?: number;
}

interface RadarChartProps {
  data: RadarDataItem[];
  showMedia?: boolean;
}

const RadarChart: React.FC<RadarChartProps> = ({ data, showMedia = false }) => {
  return (
    <ResponsiveContainer width="100%" height={350}>
      <RechartsRadarChart cx="50%" cy="50%" outerRadius="75%" data={data}>
        {/* @ts-ignore - Recharts 3.x type compatibility */}
        <PolarGrid stroke="#e2e8f0" />
        {/* @ts-ignore */}
        <PolarAngleAxis
          dataKey="dimensao"
          tick={{ fontSize: 12, fill: '#64748b' }}
        />
        {/* @ts-ignore */}
        <PolarRadiusAxis
          angle={90}
          domain={[0, 1]}
          tick={{ fontSize: 10, fill: '#94a3b8' }}
          tickFormatter={(v: number) => (v * 100).toFixed(0) + '%'}
        />
        {/* @ts-ignore */}
        <Radar
          name="Municipio"
          dataKey="percentual"
          stroke="#2563eb"
          fill="#3b82f6"
          fillOpacity={0.3}
          strokeWidth={2}
        />
        {showMedia && (
          // @ts-ignore
          <Radar
            name="Media MG"
            dataKey="mediaEstadual"
            stroke="#f97316"
            fill="#fb923c"
            fillOpacity={0.15}
            strokeWidth={2}
            strokeDasharray="5 5"
          />
        )}
        {/* @ts-ignore */}
        <Legend />
      </RechartsRadarChart>
    </ResponsiveContainer>
  );
};

export default RadarChart;
